/**
 * Mutable reference to the Redux store.
 * Used to break the circular dependency between utils.ts and store modules.
 * The store is set once during initialization in rootStore.ts.
 */

let storeRef: any = null;

export function setStoreRef(store: any) {
	storeRef = store;
}

export function getStoreRef() {
	return storeRef;
}
